import React from "react";

function FormWizard() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <rect width="28" height="28" fill="#EFF0F4" rx="2"></rect>
      <path
        stroke="#505F7B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
        d="M9 12.24v4.492"
      ></path>
      <path
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
        d="M13.668 8.498H21M13.668 10.743h4.666"
      ></path>
      <path
        stroke="#505F7B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
        d="M13.668 18.23H21M13.668 20.477h4.666"
      ></path>
      <path
        stroke="#292D32"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
        d="M9.167 11.268c1.196 0 2.166-.956 2.166-2.134 0-1.179-.97-2.134-2.166-2.134C7.97 7 7 7.955 7 9.134c0 1.178.97 2.133 2.167 2.133z"
      ></path>
      <path
        stroke="#505F7B"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
        d="M9 21c1.105 0 2-.955 2-2.134 0-1.178-.895-2.134-2-2.134s-2 .956-2 2.134C7 20.045 7.895 21 9 21z"
      ></path>
    </svg>
  );
}

export default FormWizard;